import React from 'react';
import { fromJS } from 'immutable';
import config from '../config/app.json';
import { FormattedMessage } from 'react-intl';
import { errorlog } from '../helpers/ErrorLogService';

class HyperLinkToolBarComponent extends React.Component{
    constructor(props){
        super(props);
        this.appUrl = config['APPICONS'][config['APPICONS']['current']];
        this.assetUrl = config['ASSETS'][config['ASSETS']['current']];
        this.removeLink=this.removeLink.bind(this);
        this.goToLinkpage=this.goToLinkpage.bind(this);
        
    }

    getCorner(pivotX, pivotY, cornerX, cornerY, angle) {
        var x, y, distance, diffX, diffY;
    
        /// get distance from center to point
        diffX = cornerX - pivotX;
        diffY = cornerY - pivotY;
        distance = Math.sqrt(diffX * diffX + diffY * diffY);
    
        /// find angle from pivot to corner
        angle += Math.atan2(diffY, diffX);
    
        /// get new x and y and round it off to integer
        x = pivotX + distance * Math.cos(angle);
        y = pivotY + distance * Math.sin(angle);
    
        return { x: x, y: y };
      }
    
      getSelectionBoxBounds(data) {
        var angle = data.angle * Math.PI / 180
        var c1, c2, c3, c4,    /// corners
          bx1, by1, bx2, by2, bounds;
        c1 = this.getCorner(data.cx, data.cy, data.x, data.y, angle);
        c2 = this.getCorner(data.cx, data.cy, data.x + data.width, data.y, angle);
        c3 = this.getCorner(data.cx, data.cy, data.x + data.width, data.y + data.height, angle);
        c4 = this.getCorner(data.cx, data.cy, data.x, data.y + data.height, angle);
        /// get bounding box
        bx1 = Math.min(c1.x, c2.x, c3.x, c4.x);
        by1 = Math.min(c1.y, c2.y, c3.y, c4.y);
        bx2 = Math.max(c1.x, c2.x, c3.x, c4.x);
        by2 = Math.max(c1.y, c2.y, c3.y, c4.y);
    
        bounds = { x: parseFloat(bx1.toFixed(2)), y: parseFloat(by1.toFixed(2)), width: parseFloat((bx2 - bx1).toFixed(2)), height: parseFloat((by2 - by1).toFixed(2)) };
    
        return bounds;
      }
    
      getObjectsBounds(objects, zoomFactor) {
        var minX = 0, maxX = 0, minY = 0, maxY = 0, width = 0, height = 0;
        var count = 0;
        objects.entrySeq().forEach(([key, item]) => {
          let bounds, x, y, width, height;
          bounds = this.getSelectionBoxBounds({ x: item.get("x"), y: item.get("y"), cx: item.get("x") + item.get("width") / 2, cy: item.get("y") + item.get("height") / 2, width: item.get("width"), height: item.get("height"), angle: item.get("angle") });
          
          x = bounds.x; y = bounds.y; width = bounds.width; height = bounds.height;
    
          if (count === 0) {
            minX = x; maxX = x + width; minY = y; maxY = y + height;
            count++;
          } else {
            minX = Math.min(minX, x); maxX = Math.max(maxX, x + width); minY = Math.min(minY, y); maxY = Math.max(maxY, y + height);
          }
        });
        
        width = (maxX - minX) * this.props.zoomFactor; height = (maxY - minY) * this.props.zoomFactor; minX *= this.props.zoomFactor; minY *= this.props.zoomFactor;
  
        let x = (this.props.workspaceWidth * this.props.zoomFactor <= this.props.workspaceBounds.get("width"))?this.props.workspaceBounds.get("cx") - (this.props.workspaceWidth * this.props.zoomFactor) / 2:this.props.workspaceBounds.get("cx") - this.props.workspaceBounds.get("width") / 2, y = (this.props.workspaceHeight * this.props.zoomFactor <= this.props.workspaceBounds.get("height"))?this.props.workspaceBounds.get("cy") - (this.props.workspaceHeight * this.props.zoomFactor) / 2:this.props.workspaceBounds.get("cy") - this.props.workspaceBounds.get("height") / 2;
       
        return { x: x + minX, y: y + minY, width: width, height: height };
       
      }
  
 

    getToolBarXY(){
      
        let allItems;
       
        if(this.props.selectedItems.size > 0){
            allItems = this.props.selectedObjects;
            if(this.props.selectedItems.size === 1){
              let item = this.props.selectedObjects.first();
              
            }
          }        
        
        
        if(allItems !== undefined){
          let bounds = this.getObjectsBounds(allItems, this.props.zoomFactor);
          var stageLeft   = this.props.workspaceStage.getIn(["left", "menu"]);
          var stageTop    = this.props.workspaceStage.getIn(["top", "menu"]);
          var stageRight  = window.innerWidth;
  
          if( document.getElementsByClassName("app-lib-container")[0].className.indexOf("opened") !== -1)
            stageLeft += this.props.workspaceStage.getIn(["left", "library"]);
          
          if(this.props.propertyWindow.get("isOpened") === true && document.getElementsByClassName("property-window-container")[0]){
            stageRight -= document.getElementsByClassName("property-window-container")[0].offsetWidth;
          }
          else if(this.props.showSlidePanel){
            stageRight -= document.getElementsByClassName("slide-panel")[0].offsetWidth;
          }
         
          let toolBarX  = bounds.x + bounds.width + 10, toolBarY = bounds.y;
  
          return {x : toolBarX, y : toolBarY};
        }
        else{
          return {x : stageRight - this.hyperlinkContainer.offsetWidth - 10, y : stageTop + 10};
        }
      }
  
    
      componentDidMount(){
        let toolBarXY =  this.getToolBarXY();
        this.hyperlinkContainer.style.left = (toolBarXY.x-this.hyperlinkContainer.offsetWidth-10)+ "px";
        this.hyperlinkContainer.style.top  = (toolBarXY.y-this.hyperlinkContainer.offsetHeight - 10) + "px";
      }
  
      componentDidUpdate(prevProps, prevState){
          let toolBarXY =  this.getToolBarXY();
          this.hyperlinkContainer.style.left = (toolBarXY.x - this.hyperlinkContainer.offsetWidth-10)+ "px";
          this.hyperlinkContainer.style.top  = (toolBarXY.y-this.hyperlinkContainer.offsetHeight - 10) + "px";
      }
  
      removeLink(e){
      try{
        if(this.props.isaddLinkToObj){
        this.props.addLinkToObj({selectedScene:this.props.selectedScene,selectedItem : this.props.selectedItems.get(0),linkData:{'link': '' }} , this.props.socket);
        }
        else{
        this.props.addLinkToText({selectedScene:this.props.selectedScene,container :this.props.textStatus.get('container'),selectedItem : this.props.textStatus.get('id'),hyperLinkData:{'link': ''}} , this.props.socket)
          
        }
      }catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "HyperLinkToolBarComponent-removeLink")
     }
    
      }
    
      goToLinkpage(e){
        try{
        e.preventDefault(); 
        if(!this.props.hyperlinkText.match("^Slide")){
          let url=this.props.hyperlinkText;
          const newWindow = (url.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)!==null)? window.open('/','_self'):window.open('/');

            if (url.indexOf("https://") !== 0&&url.indexOf("http://") !== 0){
                 if(url.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)!==null)
                   url='mailto:' + url;
                  else
                   url='http://' + url;
              }
             newWindow.location=url;         
          }
          else{
            let curSlide=parseInt(this.props.hyperlinkText.replace(/[^0-9\.]+/g, ""));
            this.props.setSelectedScene(curSlide-1, this.props.scenes.getIn([curSlide-1,'startTime']), [curSlide-1], this.props.socket); 
          }
        }catch (error) {
          //Error Severity: LOW
          errorlog(error, error.message, "HyperLinkToolBarComponent-goToLinkpage")
      }
      }

    render(){
        return(
        <div   ref={(instance) => this.hyperlinkContainer = instance}  className='hyperlink-tool-bar' >
         <div  className={'hyperlink-Contentbox'}>
          <div className='url-holder'>
     {this.props.hyperlinkText.match("^Slide")?  <div className='slide-main' style={{width:'20px',right:'5px'}}>
        <div className='slide-first'> <span   className='slide-content'>{this.props.hyperlinkText.replace(/[^0-9\.]+/g, "")}</span></div>
        <div className='slide-second'></div>
        </div>:<img alt='url' src={this.appUrl+'/images/url.svg'} style={{width:'18px',height:'18px',marginLeft:'4px',marginTop:'8px'}}/>}
        <div style={{color:'#414758',textAlign:'center',padding:'8px',cursor:'pointer',userSelect: 'none',overflow: 'hidden',textOverflow: 'ellipsis',whiteSpace:'nowrap',overflow:'hidden',maxWidth: '315px'}} onClick={(e)=>this.goToLinkpage(e)} >{this.props.hyperlinkText}</div>
          </div>
          
          <div style={{padding:'8px',cursor:'pointer',borderLeft:'1px solid #8796c1'}} className='hl-remove'
          onMouseMove = {(e) => {
            let toolTip = document.querySelector('.hl_remove_tool_tip');
            let toolItem = document.querySelector('.hl-remove');
            if(toolItem){
                if(toolTip){
                    toolTip.style.display = '';
                    toolTip.style.top = e.clientY + 15 + 'px';
                    toolTip.style.left = e.clientX - toolTip.offsetWidth/2+'px';
                }
            }
        }} onMouseLeave = {(e) => {
            let toolTip = document.querySelector('.hl_remove_tool_tip');
            if(toolTip){
                toolTip.style.display = 'none';
            }
        }}onClick={(e)=>{this.removeLink(e);
          let toolTip = document.querySelector('.hl_remove_tool_tip');
        if(toolTip){
            toolTip.style.display = 'none';
        }}}
            >
          <img alt='url' src={this.appUrl+'/images/deleteLink.svg'} style={{width:'18px',height:'18px',marginTop:'8px'}}/>
          </div>

         </div>
         <FormattedMessage id="hl.t.t" children={(val) => (
                            <div className={"hl_remove_tool_tip"} style={{'display' : 'none','float':'right'}}>{val}</div>
            )}></FormattedMessage>
         </div>
        )
    }
}

export default HyperLinkToolBarComponent;





// WEBPACK FOOTER //
// ./src/components/HyperLinkToolBarComponent.js